import React from "react";

const labels = {
  available: { english: "Available", arabic: "متوفر" },
  "selection-required": { english: "Select an option", arabic: "اختر أحد الخيارات" },
  preorder: { english: "Pre-order", arabic: "طلب مسبق" },
  "out-of-stock": { english: "Out of stock", arabic: "غير متوفر" },
  unavailable: { english: "Unavailable", arabic: "غير متاح" },
};

const colors = {
  available: { background: "#e8f5e9", foreground: "#237a36" },
  "selection-required": { background: "#eef3ff", foreground: "#315ea8" },
  preorder: { background: "#fff4df", foreground: "#8a5a00" },
  "out-of-stock": { background: "#f5f5f5", foreground: "#666" },
  unavailable: { background: "#f5f5f5", foreground: "#666" },
};

const AvailabilityToken = ({ availability, language = "english" }) => {
  if (!availability || !labels[availability.status]) return null;
  if (availability.status === "available") return null;
  const palette = colors[availability.status];
  return (
    <span
      role="status"
      data-availability={availability.status}
      style={{
        backgroundColor: palette.background,
        borderRadius: 10,
        color: palette.foreground,
        display: "inline-block",
        fontSize: 11,
        fontWeight: 600,
        lineHeight: "18px",
        padding: "0 7px",
      }}
    >
      {labels[availability.status][language === "arabic" ? "arabic" : "english"]}
    </span>
  );
};

export default AvailabilityToken;
